import {
  CREATE_MERCHANT_FAILD,
  CREATE_MERCHANT_LOADING,
  CREATE_MERCHANT_SUCCESS,
  REMOVE_CREATE_MERCHANT,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  data: null,
  status: null,
};

export const createMerchantReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case CREATE_MERCHANT_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case CREATE_MERCHANT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: action.status,
        error: null,
      };
    case CREATE_MERCHANT_FAILD:
      return {
        ...state,
        loading: false,
        data: null,
        status: action.status,
        error: action.error,
      };
    case REMOVE_CREATE_MERCHANT:
      return initialState;
    default:
      return state;
  }
};
